// EmailTracking class to handle email click events
class EmailTracking {
  constructor() {
    this.initMutationObserver();
    this.initEmailTracking();
  }

  initMutationObserver() {
    // Create a MutationObserver to watch for table updates
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.target.id === 'suppliers-table-body') {
          this.initEmailTracking();
        }
      });
    });

    // Start observing the table body for changes
    const tableBody = document.getElementById('suppliers-table-body');
    if (tableBody) {
      observer.observe(tableBody, {
        childList: true,
        subtree: true
      });
    }
  }

  initEmailTracking() {
    const emailLinks = document.querySelectorAll('[data-email-tracking]');
    
    emailLinks.forEach(link => {
      // Remove existing listener to prevent duplicates
      link.removeEventListener('click', this.handleEmailClick);
      // Add fresh click listener
      link.addEventListener('click', this.handleEmailClick);
    });
  }

  handleEmailClick(event) {
    event.preventDefault();
    const email = this.getAttribute('data-email-tracking');
    const id = this.getAttribute('data-entry-id');
    
    // Copy email to clipboard
    navigator.clipboard.writeText(email);
    
    // Get CSRF token from meta tag
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    
    // Send tracking request
    fetch('/actions/emailtracking/tracking/increment', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({ 
        emailAddress: email,
        entryId: id
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      console.log('Email tracking saved');
    })
    .catch(error => {
      console.error('Failed to track email copy:', error);
    });
  }
}